import { render, staticRenderFns } from "./RPNavTab.vue?vue&type=template&id=9434dfa4&"
import script from "./RPNavTab.vue?vue&type=script&lang=js&"
export * from "./RPNavTab.vue?vue&type=script&lang=js&"
import style0 from "./RPNavTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RPNavTab.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports